module.exports = __webpack_public_path__ + "img/fb.261dd3bf.png";